// src/modules/assetManagement/routes.tsx
// Customer Manager routes: Library (Events / Products / Assets tabs) and Asset Management.
// Rendered inside <Route path="/customer-manager/*"> in App.tsx.
import { Navigate, Route } from "react-router-dom";
import ProtectedRoute from "../../pages/ProtectedRoute";
import AssetDetail from "./library/AssetDetail";
import LibraryAssets from "./library/LibraryAssets";
import LibraryPage from "./library/LibraryPage";
import { LibraryEvents, LibraryProducts } from "./library/LibraryTeamPages";
import AssetManagementPage from "./management/AssetManagementPage";
import ManagedAssetPage from "./management/ManagedAssetPage";
import { UploadQueueLayout } from "./management/UploadQueueContext";

export const customerManagerAssetRoutes = (
  <>
    <Route
      path="library"
      element={
        <ProtectedRoute>
          <LibraryPage />
        </ProtectedRoute>
      }
    >
      <Route index element={<Navigate to="events" replace />} />
      <Route path="events" element={<LibraryEvents />} />
      <Route path="products" element={<LibraryProducts />} />
      <Route path="assets" element={<LibraryAssets />} />
      <Route path="assets/:assetId" element={<AssetDetail />} />
    </Route>
    <Route
      path="asset-management"
      element={
        <ProtectedRoute>
          <UploadQueueLayout />
        </ProtectedRoute>
      }
    >
      <Route index element={<AssetManagementPage />} />
      <Route path="assets/:assetId" element={<ManagedAssetPage />} />
    </Route>
  </>
);
